/**
 * AiLimitReachedBanner — displayed when promptsUsed === AI_PROMPT_LIMIT.
 *
 * Makes the cap visible and explains why no further input is possible.
 * Also surfaces the consent/server-enforcement note for practitioners.
 */

import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import { LockOutlined } from "@mui/icons-material";
import { AI_PROMPT_LIMIT } from "./assessmentAi.mock";

export const AiLimitReachedBanner = (): JSX.Element => (
    <Alert severity="warning" icon={<LockOutlined fontSize="inherit" />} sx={{ borderRadius: 2 }}>
        <AlertTitle>Session limit reached</AlertTitle>
        You have used all {AI_PROMPT_LIMIT} AI prompts available for this assessment session. This limit is enforced to
        maintain responsible AI use over participant wellbeing data. If you need further analysis, please speak with
        your programme manager.
    </Alert>
);
